export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-2-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "action", name: "热血", icon: "ri-fire-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "drama", name: "剧情", icon: "ri-emotion-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-happy-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "bl", name: "BL", icon: "ri-user-heart-line" },
  { slug: "gl", name: "GL", icon: "ri-women-line" },
  { slug: "school", name: "校园", icon: "ri-building-line" },
  { slug: "office", name: "职场", icon: "ri-briefcase-line" },
  { slug: "historical", name: "古风", icon: "ri-ancient-gate-line" },
];

export const comics = [
  {
    id: 1,
    title: "社内相亲",
    slug: "office-romance",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20office%20couple%2C%20elegant%20man%20and%20woman%20in%20business%20attire%20looking%20at%20each%20other%20with%20tender%20eyes%2C%20soft%20warm%20lighting%2C%20clean%20modern%20office%20background%2C%20delicate%20lineart%2C%20pastel%20color%20palette%2C%20webtoon%20cover%20style&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    author: "海潮",
    status: "连载中",
    rating: 9.2,
    views: 1280000,
    description: "平凡上班族申夏莉代替闺蜜去相亲，却意外发现相亲对象竟是自己的社长姜泰武。一场伪装身份与真心交织的办公室浪漫故事就此展开。",
    chapters: 86,
    updateDate: "2026-08-03",
    tags: ["恋爱", "职场", "喜剧"],
    featured: true,
  },
  {
    id: 2,
    title: "我独自升级",
    slug: "solo-leveling",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20stylish%20Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20hunter%20with%20glowing%20blue%20eyes%20and%20black%20armor%2C%20holding%20a%20dagger%2C%20dramatic%20shadow%20and%20light%20contrast%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20character%20design%2C%20dark%20monochrome%20with%20blue%20accents&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    author: "Chugong",
    status: "已完结",
    rating: 9.8,
    views: 5680000,
    description: "十年前，世界各地出现了连接异次元与现世的「传送门」，觉醒的人类被称为「猎人」。最弱猎人成振宇在一次双重地下城任务中濒死，却获得了神秘系统的能力，从此踏上独自升级之路。",
    chapters: 179,
    updateDate: "2026-07-15",
    tags: ["热血", "奇幻", "系统"],
    featured: true,
  },
  {
    id: 3,
    title: "女神降临",
    slug: "true-beauty",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20style%20cover%20of%20a%20beautiful%20young%20woman%20with%20flawless%20makeup%20looking%20into%20a%20mirror%2C%20surrounded%20by%20cosmetics%2C%20soft%20pink%20and%20peach%20color%20scheme%2C%20elegant%20bedroom%20background%2C%20shojo%20manga%20aesthetic%2C%20sparkling%20effects&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    author: "Yaongyi",
    status: "已完结",
    rating: 9.0,
    views: 3890000,
    description: "因外貌在学校遭受欺凌的任朱静，通过化妆技巧华丽变身成为校园女神。然而她始终活在害怕素颜被揭穿的恐惧中，直到遇见了唯一知道她秘密的李修豪。",
    chapters: 156,
    updateDate: "2026-06-20",
    tags: ["恋爱", "校园", "美妆"],
    featured: true,
  },
  {
    id: 4,
    title: "全知读者视角",
    slug: "omniscient-reader",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20illustration%20of%20a%20man%20holding%20a%20glowing%20book%20in%20a%20post-apocalyptic%20world%2C%20fantasy%20monsters%20in%20background%2C%20constellation%20stars%20above%2C%20detailed%20cinematic%20lighting%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20epic%20scale&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    author: "sing N song",
    status: "连载中",
    rating: 9.7,
    views: 4520000,
    description: "金独子是唯一读完长达3149话网络小说《在灭亡的世界中生存的三种方法》的读者。当小说中的世界突然成为现实，作为唯一知晓所有剧情的人，他必须在这个末日世界里生存下去。",
    chapters: 210,
    updateDate: "2026-08-02",
    tags: ["奇幻", "末世", "系统"],
    featured: true,
  },
  {
    id: 5,
    title: "他人即地狱",
    slug: "strangers-from-hell",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20psychological%20thriller%20Korean%20manhwa%20cover%2C%20a%20young%20man%20looking%20terrified%20in%20a%20dimly%20lit%20corridor%20of%20an%20old%20apartment%20building%2C%20shadowy%20figures%20behind%20doors%2C%20eerie%20atmosphere%2C%20muted%20red%20and%20black%20tones%2C%20horror%20webtoon%20style&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    author: "金容基",
    status: "已完结",
    rating: 9.3,
    views: 2150000,
    description: "从乡下来到首尔的尹钟宇住进了一间便宜考试院，却发现这里的住户一个比一个诡异。牙医徐文祖对他表现出异常的兴趣，而考试院里接连发生的失踪事件，让钟宇一步步坠入深渊。",
    chapters: 56,
    updateDate: "2026-05-10",
    tags: ["悬疑", "恐怖", "心理"],
    featured: false,
  },
  {
    id: 6,
    title: "流氓读书会",
    slug: "study-group",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20manhwa%20cover%2C%20a%20high%20school%20student%20in%20uniform%20throwing%20a%20punch%20with%20intense%20expression%2C%20school%20hallway%20background%20with%20motion%20lines%2C%20bold%20red%20and%20black%20color%20scheme%2C%20fighting%20webtoon%20art%20style&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    author: "申炯旭",
    status: "连载中",
    rating: 9.1,
    views: 1870000,
    description: "尹歌旻是想好好学习考上大学的高中生，但他就读的是全国最烂的流氓学校。为了守护自己的学习小组，他不得不展现出惊人的格斗实力，一场用拳头守护梦想的热血故事。",
    chapters: 94,
    updateDate: "2026-08-01",
    tags: ["热血", "校园", "格斗"],
    featured: false,
  },
  {
    id: 7,
    title: "某天成为公主",
    slug: "who-made-me-a-princess",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20Korean%20manhwa%20cover%20of%20a%20young%20princess%20with%20long%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20elegant%20gown%2C%20royal%20palace%20in%20background%2C%20soft%20golden%20and%20pink%20lighting%2C%20fairy%20tale%20European%20setting%2C%20delicate%20shojo%20art%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    author: "Plutus",
    status: "已完结",
    rating: 9.5,
    views: 3420000,
    description: "醒来后发现自己成了小说中即将被亲生父亲处死的悲剧公主阿塔纳希娅。为了活下去，她必须想尽办法在冷酷无情的皇帝父亲面前刷存在感。一场公主的生存攻略就此展开。",
    chapters: 125,
    updateDate: "2026-04-30",
    tags: ["奇幻", "穿越", "父女"],
    featured: false,
  },
  {
    id: 8,
    title: "反派女主的生存法则",
    slug: "villainess-survival",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20cover%20of%20a%20villainess%20noblewoman%20with%20dark%20hair%20and%20red%20lips%20in%20a%20luxurious%20black%20and%20red%20gown%2C%20holding%20a%20fan%2C%20ornate%20palace%20ballroom%20background%2C%20rich%20jewel%20tones%2C%20dramatic%20lighting%2C%20rofan%20style&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    author: "尤伊",
    status: "连载中",
    rating: 9.0,
    views: 1560000,
    description: "穿越成为小说中注定悲惨死去的反派女配角，为了改变命运，她决定远离男女主角，过好自己的生活。但为什么所有人都对她穷追不舍？说好的远离怎么变成了团宠？",
    chapters: 78,
    updateDate: "2026-08-03",
    tags: ["奇幻", "穿越", "恶役"],
    featured: false,
  },
  {
    id: 9,
    title: "甜蜜的陷阱",
    slug: "sweet-trap",
    category: "bl",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20BL%20Korean%20manhwa%20cover%20of%20two%20handsome%20young%20men%20facing%20each%20other%20tenderly%2C%20one%20with%20dark%20hair%20and%20the%20other%20with%20light%20brown%20hair%2C%20soft%20pastel%20color%20scheme%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20spring%20atmosphere%2C%20delicate%20art%20style&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    author: "苏打",
    status: "连载中",
    rating: 8.8,
    views: 980000,
    description: "甜品店老板林逸辰遇到了每天都会来买同一款蛋糕的神秘男人。随着深入了解，他发现这个看似冷漠的男人背后藏着一段不为人知的伤感往事。",
    chapters: 45,
    updateDate: "2026-07-28",
    tags: ["BL", "甜品", "治愈"],
    featured: false,
  },
  {
    id: 10,
    title: "她的私生活",
    slug: "her-private-life",
    category: "gl",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20GL%20Korean%20manhwa%20cover%20of%20two%20women%20sitting%20close%20together%20in%20a%20cozy%20coffee%20shop%2C%20sunlight%20streaming%20through%20window%2C%20one%20woman%20with%20short%20hair%20and%20the%20other%20with%20long%20wavy%20hair%2C%20warm%20and%20soft%20atmosphere%2C%20gentle%20color%20palette&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    author: "木木",
    status: "已完结",
    rating: 8.9,
    views: 720000,
    description: "表面上是完美职场女性的郑秀雅，私下却是个狂热的偶像粉丝。当她的追星秘密被新来的实习生撞破后，两人的关系开始发生微妙的变化。",
    chapters: 60,
    updateDate: "2026-06-15",
    tags: ["GL", "职场", "日常"],
    featured: false,
  },
  {
    id: 11,
    title: "高校之神",
    slug: "god-of-highschool",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20webtoon%20cover%2C%20a%20teenage%20martial%20artist%20in%20fighting%20stance%20with%20fiery%20aura%2C%20martial%20arts%20tournament%20arena%20background%2C%20explosive%20energy%20effects%2C%20vibrant%20orange%20and%20red%20color%20scheme%2C%20shonen%20battle%20style&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    author: "朴勇济",
    status: "已完结",
    rating: 9.0,
    views: 2760000,
    description: "高中生陈毛利受邀参加高校之神格斗大赛，来自全韩各地的高手齐聚一堂，争夺最强高中生称号。然而比赛的背后，隐藏着足以撼动世界的力量。",
    chapters: 212,
    updateDate: "2026-03-20",
    tags: ["热血", "格斗", "校园"],
    featured: false,
  },
  {
    id: 12,
    title: "再看我一眼",
    slug: "look-at-me-again",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20emotional%20Korean%20drama%20manhwa%20cover%2C%20a%20woman%20with%20tears%20in%20her%20eyes%20looking%20at%20a%20man%20walking%20away%20in%20the%20rain%2C%20umbrella%20on%20the%20ground%2C%20melancholic%20blue%20and%20gray%20tones%2C%20city%20street%20at%20night%2C%20poignant%20atmosphere&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    author: "雨季",
    status: "连载中",
    rating: 9.4,
    views: 1320000,
    description: "一场车祸让李恩在失去了过去五年的记忆。醒来后，她发现身边的一切都变得陌生——包括那个自称是她丈夫的男人。她想找回记忆，但真相似乎比失忆更加残酷。",
    chapters: 67,
    updateDate: "2026-08-02",
    tags: ["剧情", "失忆", "悬疑"],
    featured: false,
  },
  {
    id: 13,
    title: "我的ID是江南美人",
    slug: "my-id-is-gangnam-beauty",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20drama%20webtoon%20cover%20of%20a%20beautiful%20college%20woman%20with%20long%20black%20hair%20and%20natural%20makeup%2C%20standing%20in%20front%20of%20a%20modern%20university%20building%2C%20cherry%20blossom%20trees%2C%20soft%20spring%20sunlight%2C%20fresh%20and%20bright%20color%20palette&width=600&height=800&seq=manga-cover-13&orientation=portrait",
    author: "淇萌",
    status: "已完结",
    rating: 8.7,
    views: 1980000,
    description: "姜美来自小因外貌备受欺凌，终于通过整容手术获得新生进入大学。但她很快发现，外貌的改变并不能解决所有问题，而唯一知道她过去的都炅锡，却始终守护在她身边。",
    chapters: 80,
    updateDate: "2026-02-28",
    tags: ["剧情", "校园", "成长"],
    featured: false,
  },
  {
    id: 14,
    title: "异世界舅舅",
    slug: "uncle-from-another-world",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20cover%2C%20a%20scruffy%20middle-aged%20man%20in%20fantasy%20armor%20making%20a%20silly%20face%2C%20magical%20effects%20around%20him%2C%20colorful%20and%20playful%20style%2C%20light%20hearted%20comedy%20webtoon%20atmosphere&width=600&height=800&seq=manga-cover-14&orientation=portrait",
    author: "岛崎",
    status: "连载中",
    rating: 8.5,
    views: 860000,
    description: "高坂聪在异世界度过了十七年，回到现代后发现自己错过了整个世代。他一边用魔法在现代生活，一边给侄子讲述异世界的爆笑冒险经历——虽然在他看来都是些悲惨遭遇。",
    chapters: 52,
    updateDate: "2026-07-30",
    tags: ["搞笑", "穿越", "日常"],
    featured: false,
  },
  {
    id: 15,
    title: "再婚皇后",
    slug: "remarried-empress",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20regal%20Korean%20fantasy%20manhwa%20cover%20of%20an%20elegant%20empress%20in%20a%20magnificent%20golden%20and%20white%20gown%20with%20a%20crown%2C%20imperial%20palace%20throne%20room%20background%2C%20dignified%20expression%2C%20rich%20gold%20and%20navy%20color%20scheme%2C%20royal%20rofan%20art%20style&width=600&height=800&seq=manga-cover-15&orientation=portrait",
    author: "Alpha Tart",
    status: "连载中",
    rating: 9.3,
    views: 2890000,
    description: "东大帝国皇后娜菲尔在丈夫公然带情妇入宫后，毅然决定离婚再嫁。她选择与邻国国王缔结婚姻，开启全新人生。旧爱后悔莫及，但她已不再是那个任人摆布的皇后。",
    chapters: 112,
    updateDate: "2026-08-03",
    tags: ["奇幻", "宫斗", "逆袭"],
    featured: false,
  },
  {
    id: 16,
    title: "春日的约定",
    slug: "spring-promise",
    category: "school",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20school%20romance%20manhwa%20cover%2C%20two%20high%20school%20students%20a%20boy%20and%20girl%20sitting%20on%20rooftop%20watching%20sunset%2C%20school%20uniforms%2C%20cherry%20blossoms%2C%20warm%20golden%20hour%20lighting%2C%20youthful%20and%20nostalgic%20atmosphere%2C%20soft%20watercolor-like%20style&width=600&height=800&seq=manga-cover-16&orientation=portrait",
    author: "春天",
    status: "已完结",
    rating: 8.6,
    views: 650000,
    description: "高三最后一个春天，班长林书元与转学生苏念约定：如果能一起考上同一所大学，就在一起。青涩的暗恋，紧张的备考，属于青春最美好的约定。",
    chapters: 40,
    updateDate: "2026-05-20",
    tags: ["校园", "恋爱", "青春"],
    featured: false,
  },
];

export const faqs = [
  {
    question: "073漫画网的韩漫都是无删减版本吗？",
    answer: "是的！073漫画网所有韩国漫画均为无删减版本，保留原作完整的故事情节和画面内容。我们坚持为读者提供最原汁原味的阅读体验，绝不对内容进行任何删减或修改。",
  },
  {
    question: "什么是下拉式阅读？如何使用？",
    answer: "下拉式阅读是一种针对手机和网页优化的漫画阅读方式。您只需向下滑动页面，漫画内容就会以纵向连续的形式呈现，无需翻页。这种阅读方式最适合手机端，让您在通勤或休息时间轻松享受韩漫。",
  },
  {
    question: "073漫画网的韩漫更新频率如何？",
    answer: "我们的更新速度行业领先！热门连载作品基本保持与韩国同步更新，大部分作品每周更新一话。新章节上线后，您可以在首页「最新更新」板块第一时间看到。",
  },
  {
    question: "需要注册账号才能看漫画吗？",
    answer: "完全不需要！073漫画网所有内容完全免费，无需注册即可在线阅读。我们致力于让每一位韩漫爱好者都能无障碍地享受精彩漫画。",
  },
  {
    question: "网站上的漫画资源有多少？",
    answer: "目前073漫画网拥有超过5000部韩国漫画资源，涵盖恋爱、热血、奇幻、剧情、搞笑、悬疑、BL、GL等十多个分类。我们的资源库每天都在扩充，确保您能找到喜欢的作品。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "073漫画网采用响应式设计，完美适配电脑、平板和手机。无论是用手机在通勤路上阅读，还是用电脑在家中享受大屏体验，都能获得流畅的阅读体验。下拉式阅读模式在手机上体验尤佳。",
  },
];

export const aboutStats = [
  { label: "漫画总量", value: "5000+", icon: "ri-book-open-line" },
  { label: "日活跃用户", value: "80万+", icon: "ri-user-line" },
  { label: "累计阅读", value: "3.2亿+", icon: "ri-eye-line" },
  { label: "更新速度", value: "日更百部", icon: "ri-flashlight-line" },
];